import { animate, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, ElementRef, Injector, PLATFORM_ID, Renderer2, DOCUMENT } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { RouterLinkHelper, SafeHtmlPipe, takeWhileAlive } from '@core/frontend-shared';
import { absolutePosition__alignRight } from '@core/frontend-shared/utils/dom';
import { OverlayService, PrimeNGConfig } from 'prime-ng-old/api';
import { DomHandler } from 'prime-ng-old/dom';
import { Menu as MenuBase, MenuItemContent as MenuItemContentBase } from 'prime-ng-old/menu';
import { filter, map } from 'rxjs';
import { UiButtonComponent } from '../button';
import { UiIconsModule } from '../icons';
import { UiRouterLinkActivePathDirective } from '../router-link-active-path';
import { ScreenService } from '../screen-service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "@angular/router";
import * as i3 from "../icons/icon.component";
import * as i4 from "prime-ng-old/api";
import * as i5 from "../screen-service";
const _c0 = ["pMenuItemContent", ""];
const _c1 = a0 => ({
  "p-disabled": a0
});
const _c2 = a0 => ({
  $implicit: a0
});
const _c3 = () => ({
  isActive: "p-menuitem-link-active"
});
function MenuItemContent_Conditional_1_Conditional_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function MenuItemContent_Conditional_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 2);
    i0.ɵɵtemplate(1, MenuItemContent_Conditional_1_Conditional_0_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    const itemContent_r2 = i0.ɵɵreference(4);
    i0.ɵɵproperty("target", ctx_r0.item.target)("ngClass", i0.ɵɵpureFunction1(10, _c1, ctx_r0.item.disabled));
    i0.ɵɵattribute("title", ctx_r0.item.title)("href", ctx_r0.item.url || null, i0.ɵɵsanitizeUrl)("data-automationid", ctx_r0.item.automationId)("tabindex", -1)("data-pc-section", "action")("aria-hidden", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", itemContent_r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(12, _c2, ctx_r0.item));
  }
}
function MenuItemContent_Conditional_1_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function MenuItemContent_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 3);
    i0.ɵɵtemplate(1, MenuItemContent_Conditional_1_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    const itemContent_r2 = i0.ɵɵreference(4);
    i0.ɵɵproperty("routerLink", ctx_r0.item.routerLink)("queryParams", ctx_r0.item.queryParams)("routerLinkActivePath", i0.ɵɵpureFunction0(18, _c3))("target", ctx_r0.item.target)("ngClass", i0.ɵɵpureFunction1(19, _c1, ctx_r0.item.disabled))("fragment", ctx_r0.item.fragment)("queryParamsHandling", ctx_r0.item.queryParamsHandling)("preserveFragment", ctx_r0.item.preserveFragment)("skipLocationChange", ctx_r0.item.skipLocationChange)("replaceUrl", ctx_r0.item.replaceUrl)("state", ctx_r0.item.state);
    i0.ɵɵattribute("data-automationid", ctx_r0.item.automationId)("tabindex", -1)("data-pc-section", "action")("aria-hidden", true)("title", ctx_r0.item.title);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", itemContent_r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(21, _c2, ctx_r0.item));
  }
}
function MenuItemContent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, MenuItemContent_Conditional_1_Conditional_0_Template, 2, 14, "a", 2);
    i0.ɵɵconditionalCreate(1, MenuItemContent_Conditional_1_Conditional_1_Template, 2, 23, "a", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(!(ctx_r0.item == null ? null : ctx_r0.item.routerLink) ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((ctx_r0.item == null ? null : ctx_r0.item.routerLink) ? 1 : -1);
  }
}
function MenuItemContent_Conditional_2_0_ng_template_0_Template(rf, ctx) {}
function MenuItemContent_Conditional_2_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MenuItemContent_Conditional_2_0_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function MenuItemContent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MenuItemContent_Conditional_2_0_Template, 1, 0, null, 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.itemTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c2, ctx_r0.item));
  }
}
function MenuItemContent_ng_template_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-icon", 5);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("icon", ctx_r0.item.icon)("fixedWidth", true);
  }
}
function MenuItemContent_ng_template_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.item.label);
  }
}
function MenuItemContent_ng_template_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 7);
    i0.ɵɵpipe(1, "safeHtml");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, ctx_r0.item.label), i0.ɵɵsanitizeHtml);
  }
}
function MenuItemContent_ng_template_3_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r0.item.badgeStyleClass);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.item.badge);
  }
}
function MenuItemContent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, MenuItemContent_ng_template_3_Conditional_0_Template, 1, 2, "ui-icon", 5);
    i0.ɵɵconditionalCreate(1, MenuItemContent_ng_template_3_Conditional_1_Template, 2, 1, "span", 6)(2, MenuItemContent_ng_template_3_Conditional_2_Template, 2, 3, "span", 7);
    i0.ɵɵconditionalCreate(3, MenuItemContent_ng_template_3_Conditional_3_Template, 2, 2, "span", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.item.icon ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.item.escape !== false ? 1 : 2);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.item.badge ? 3 : -1);
  }
}
const _c4 = a0 => ({
  "p-menu p-component": true,
  "p-menu-overlay": a0
});
const _c5 = (a0, a1) => ({
  showTransitionParams: a0,
  hideTransitionParams: a1
});
const _c6 = a0 => ({
  value: "visible",
  params: a0
});
const _c7 = a0 => ({
  "p-hidden": a0
});
const _c8 = (a0, a1) => ({
  "p-hidden": a0,
  flex: a1
});
const _c9 = (a0, a1, a2) => ({
  "p-hidden": a0,
  "p-focus": a1,
  "p-disabled": a2
});
function UiMenuComponent_Conditional_0_Conditional_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiMenuComponent_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtemplate(1, UiMenuComponent_Conditional_0_Conditional_2_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("data-pc-section", "start");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.startTemplate);
  }
}
function UiMenuComponent_Conditional_0_Conditional_5_For_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "li", 8);
  }
  if (rf & 2) {
    const submenu_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c7, submenu_r3.visible === false));
  }
}
function UiMenuComponent_Conditional_0_Conditional_5_For_1_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const submenu_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(submenu_r3.label);
  }
}
function UiMenuComponent_Conditional_0_Conditional_5_For_1_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 10);
    i0.ɵɵpipe(1, "safeHtml");
  }
  if (rf & 2) {
    const submenu_r3 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(1, 1, submenu_r3.label), i0.ɵɵsanitizeHtml);
  }
}
function UiMenuComponent_Conditional_0_Conditional_5_For_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 9);
    i0.ɵɵconditionalCreate(1, UiMenuComponent_Conditional_0_Conditional_5_For_1_Conditional_1_Conditional_1_Template, 2, 1, "span")(2, UiMenuComponent_Conditional_0_Conditional_5_For_1_Conditional_1_Conditional_2_Template, 2, 3, "span", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    const submenu_r3 = ctx_r3.$implicit;
    const ɵ$index_14_r5 = ctx_r3.$index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(4, _c8, submenu_r3.visible === false, submenu_r3.visible));
    i0.ɵɵattribute("data-automationid", submenu_r3.automationId)("id", ctx_r1.menuitemId(submenu_r3, ctx_r1.id, ɵ$index_14_r5));
    i0.ɵɵadvance();
    i0.ɵɵconditional(submenu_r3.escape !== false ? 1 : 2);
  }
}
function UiMenuComponent_Conditional_0_Conditional_5_For_1_For_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "li", 8);
  }
  if (rf & 2) {
    const item_r6 = i0.ɵɵnextContext().$implicit;
    const submenu_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c7, item_r6.visible === false || submenu_r3.visible === false));
  }
}
function UiMenuComponent_Conditional_0_Conditional_5_For_1_For_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 12);
    i0.ɵɵlistener("onMenuItemClick", function UiMenuComponent_Conditional_0_Conditional_5_For_1_For_3_Conditional_1_Template_li_onMenuItemClick_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r7 = i0.ɵɵnextContext();
      const item_r6 = ctx_r7.$implicit;
      const ɵ$index_29_r9 = ctx_r7.$index;
      const ɵ$index_14_r5 = i0.ɵɵnextContext().$index;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.itemClick($event, ctx_r1.menuitemId(item_r6, ctx_r1.id, ɵ$index_14_r5, ɵ$index_29_r9)));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    const item_r6 = ctx_r7.$implicit;
    const ɵ$index_29_r9 = ctx_r7.$index;
    const ctx_r3 = i0.ɵɵnextContext();
    const submenu_r3 = ctx_r3.$implicit;
    const ɵ$index_14_r5 = ctx_r3.$index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(item_r6.styleClass);
    i0.ɵɵproperty("pMenuItemContent", item_r6)("itemTemplate", ctx_r1.itemTemplate)("ngClass", i0.ɵɵpureFunction3(12, _c9, item_r6.visible === false || submenu_r3.visible === false, ctx_r1.isItemFocused(ctx_r1.menuitemId(item_r6, ctx_r1.id, ɵ$index_14_r5, ɵ$index_29_r9)), ctx_r1.disabled(item_r6.disabled)))("ngStyle", item_r6.style);
    i0.ɵɵattribute("data-pc-section", "menuitem")("aria-label", ctx_r1.label(item_r6.label))("data-p-focused", ctx_r1.isItemFocused(ctx_r1.menuitemId(item_r6, ctx_r1.id, ɵ$index_14_r5, ɵ$index_29_r9)))("data-p-disabled", ctx_r1.disabled(item_r6.disabled))("aria-disabled", ctx_r1.disabled(item_r6.disabled))("id", ctx_r1.menuitemId(item_r6, ctx_r1.id, ɵ$index_14_r5, ɵ$index_29_r9));
  }
}
function UiMenuComponent_Conditional_0_Conditional_5_For_1_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, UiMenuComponent_Conditional_0_Conditional_5_For_1_For_3_Conditional_0_Template, 1, 3, "li", 8);
    i0.ɵɵconditionalCreate(1, UiMenuComponent_Conditional_0_Conditional_5_For_1_For_3_Conditional_1_Template, 1, 16, "li", 11);
  }
  if (rf & 2) {
    const item_r6 = ctx.$implicit;
    i0.ɵɵconditional(item_r6.separator ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!item_r6.separator ? 1 : -1);
  }
}
function UiMenuComponent_Conditional_0_Conditional_5_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, UiMenuComponent_Conditional_0_Conditional_5_For_1_Conditional_0_Template, 1, 3, "li", 8);
    i0.ɵɵconditionalCreate(1, UiMenuComponent_Conditional_0_Conditional_5_For_1_Conditional_1_Template, 3, 7, "li", 9);
    i0.ɵɵrepeaterCreate(2, UiMenuComponent_Conditional_0_Conditional_5_For_1_For_3_Template, 2, 2, null, null, i0.ɵɵrepeaterTrackByIdentity);
  }
  if (rf & 2) {
    const submenu_r3 = ctx.$implicit;
    i0.ɵɵconditional(submenu_r3.separator ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!submenu_r3.separator ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(submenu_r3.items);
  }
}
function UiMenuComponent_Conditional_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, UiMenuComponent_Conditional_0_Conditional_5_For_1_Template, 4, 2, null, null, i0.ɵɵrepeaterTrackByIdentity);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵrepeater(ctx_r1.model);
  }
}
function UiMenuComponent_Conditional_0_Conditional_6_For_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "li", 8);
  }
  if (rf & 2) {
    const item_r10 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c7, item_r10.visible === false));
  }
}
function UiMenuComponent_Conditional_0_Conditional_6_For_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 12);
    i0.ɵɵlistener("onMenuItemClick", function UiMenuComponent_Conditional_0_Conditional_6_For_1_Conditional_1_Template_li_onMenuItemClick_0_listener($event) {
      i0.ɵɵrestoreView(_r11);
      const ctx_r11 = i0.ɵɵnextContext();
      const item_r10 = ctx_r11.$implicit;
      const ɵ$index_37_r13 = ctx_r11.$index;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.itemClick($event, ctx_r1.menuitemId(item_r10, ctx_r1.id, ɵ$index_37_r13)));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    const item_r10 = ctx_r11.$implicit;
    const ɵ$index_37_r13 = ctx_r11.$index;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(item_r10.styleClass);
    i0.ɵɵproperty("pMenuItemContent", item_r10)("itemTemplate", ctx_r1.itemTemplate)("ngClass", i0.ɵɵpureFunction3(12, _c9, item_r10.visible === false, ctx_r1.isItemFocused(ctx_r1.menuitemId(item_r10, ctx_r1.id, ɵ$index_37_r13)), ctx_r1.disabled(item_r10.disabled)))("ngStyle", item_r10.style);
    i0.ɵɵattribute("data-pc-section", "menuitem")("aria-label", ctx_r1.label(item_r10.label))("data-p-focused", ctx_r1.isItemFocused(ctx_r1.menuitemId(item_r10, ctx_r1.id, ɵ$index_37_r13)))("data-p-disabled", ctx_r1.disabled(item_r10.disabled))("aria-disabled", ctx_r1.disabled(item_r10.disabled))("id", ctx_r1.menuitemId(item_r10, ctx_r1.id, ɵ$index_37_r13));
  }
}
function UiMenuComponent_Conditional_0_Conditional_6_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, UiMenuComponent_Conditional_0_Conditional_6_For_1_Conditional_0_Template, 1, 3, "li", 8);
    i0.ɵɵconditionalCreate(1, UiMenuComponent_Conditional_0_Conditional_6_For_1_Conditional_1_Template, 1, 16, "li", 11);
  }
  if (rf & 2) {
    const item_r10 = ctx.$implicit;
    i0.ɵɵconditional(item_r10.separator ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!item_r10.separator ? 1 : -1);
  }
}
function UiMenuComponent_Conditional_0_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, UiMenuComponent_Conditional_0_Conditional_6_For_1_Template, 2, 2, null, null, i0.ɵɵrepeaterTrackByIdentity);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵrepeater(ctx_r1.model);
  }
}
function UiMenuComponent_Conditional_0_Conditional_7_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiMenuComponent_Conditional_0_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, UiMenuComponent_Conditional_0_Conditional_7_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("data-pc-section", "end");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.endTemplate);
  }
}
function UiMenuComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3, 0);
    i0.ɵɵlistener("click", function UiMenuComponent_Conditional_0_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onOverlayClick($event));
    })("@overlayAnimation.start", function UiMenuComponent_Conditional_0_Template_div_animation_overlayAnimation_start_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onOverlayAnimationStart($event));
    })("@overlayAnimation.done", function UiMenuComponent_Conditional_0_Template_div_animation_overlayAnimation_done_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onOverlayAnimationEnd($event));
    });
    i0.ɵɵconditionalCreate(2, UiMenuComponent_Conditional_0_Conditional_2_Template, 2, 2, "div", 4);
    i0.ɵɵelementStart(3, "ul", 5, 1);
    i0.ɵɵlistener("focus", function UiMenuComponent_Conditional_0_Template_ul_focus_3_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onListFocus($event));
    })("blur", function UiMenuComponent_Conditional_0_Template_ul_blur_3_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onListBlur($event));
    })("keydown", function UiMenuComponent_Conditional_0_Template_ul_keydown_3_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onListKeyDown($event));
    });
    i0.ɵɵconditionalCreate(5, UiMenuComponent_Conditional_0_Conditional_5_Template, 2, 0);
    i0.ɵɵconditionalCreate(6, UiMenuComponent_Conditional_0_Conditional_6_Template, 2, 0);
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(7, UiMenuComponent_Conditional_0_Conditional_7_Template, 2, 2, "div", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.styleClass);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c4, ctx_r1.popup))("ngStyle", ctx_r1.style)("@overlayAnimation", i0.ɵɵpureFunction1(23, _c6, i0.ɵɵpureFunction2(20, _c5, ctx_r1.showTransitionOptions, ctx_r1.hideTransitionOptions)))("@.disabled", ctx_r1.popup !== true);
    i0.ɵɵattribute("data-pc-name", "menu")("id", ctx_r1.id);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.startTemplate ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵattribute("id", ctx_r1.id + "_list")("tabindex", ctx_r1.getTabIndexValue())("data-pc-section", "menu")("aria-activedescendant", ctx_r1.activedescendant())("aria-label", ctx_r1.ariaLabel)("aria-labelledBy", ctx_r1.ariaLabelledBy);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.hasSubMenu() ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.hasSubMenu() ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.endTemplate ? 7 : -1);
  }
}
const _c10 = "@layer primeng{.p-menu-overlay{position:absolute;top:0;left:0}.p-menu ul{margin:0;padding:0;list-style:none}.p-menu .p-submenu-header{align-items:center}.p-menu .p-menuitem-link{cursor:pointer;display:flex;align-items:center;text-decoration:none;overflow:hidden;position:relative}.p-menu .p-menuitem-text{line-height:1}}.p-menu{padding:0;background-color:var(--menuBgColor);border:0;border-color:var(--menuBorderColor);width:auto;min-width:200px}.p-menu .p-menuitem{margin:0}.p-menu .p-menuitem.p-focus .p-menuitem-link:not(.p-menuitem-link-active){background-color:var(--focusColor)!important;border-color:var(--focusColor)!important}body.a11y-emphasize-focus .p-menu .p-menuitem.p-focus .p-menuitem-link:not(.p-menuitem-link-active){transform:scale(1.1)!important}body.a11y-emphasize-focus .p-menu .p-menuitem.p-focus .p-menuitem-link.p-menuitem-link-active{outline:var(--a11yFocusedElementOutline)!important;outline-offset:-2px!important}.p-menu .p-submenu-header{margin:0;padding:8px 10px;color:var(--panelHeaderTextColor);background-color:var(--panelHeaderBgColor);font-weight:400;border:0 none}.p-menu.p-menu-overlay{background-color:var(--overlayMenuBgColor);border:1px solid #c8c8c8;border-color:var(--overlayMenuBorderColor);box-shadow:1px 5px 6px #00000073}.p-menu .p-menuitem-link{padding:10px 12px;font-weight:400;border-radius:0;color:var(--menuitemTextColor)}.p-menu .p-menuitem-link .p-menuitem-text{color:var(--menuitemTextColor)}.p-menu .p-menuitem-link .p-menuitem-icon{color:var(--menuitemIconColor);margin-right:.5em;width:22px;display:inline-block;text-align:center}.p-menu .p-menuitem-link:hover{background-color:var(--menuitemHoverBgColor)}.p-menu .p-menuitem-link:hover .p-menuitem-text{color:var(--menuitemHoverTextColor)}.p-menu .p-menuitem-link:hover .p-menuitem-icon{color:var(--menuitemHoverIconColor)}.p-menu .p-menuitem-link.p-menuitem-link-active{background-color:var(--menuitemHoverBgColor)}.p-menu .p-menuitem-link.p-menuitem-link-active .p-menuitem-text{color:var(--menuitemHoverTextColor)}.p-menu .p-menuitem-link.p-menuitem-link-active .p-menuitem-icon{color:var(--menuitemHoverIconColor)}body.a11y-no-distraction-mode .p-menu .p-menuitem-icon{display:none}\n";
const _c11 = ["contentMenu"];
function UiMenuWithMobileTransitionComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵlistener("click", function UiMenuWithMobileTransitionComponent_Conditional_0_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      i0.ɵɵnextContext();
      const contentMenu_r2 = i0.ɵɵreference(3);
      return i0.ɵɵresetView(contentMenu_r2.toggle($event));
    });
    i0.ɵɵelement(1, "button", 4);
    i0.ɵɵelementStart(2, "h3", 5);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.activeMenuItemTitle);
  }
}
export let MenuItemContent = /*#__PURE__*/(() => {
  class MenuItemContent extends MenuItemContentBase {
    constructor(injector) {
      super(injector.get(UiMenuComponent));
    }
    static {
      this.ɵfac = function MenuItemContent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MenuItemContent)(i0.ɵɵdirectiveInject(i0.Injector));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: MenuItemContent,
        selectors: [["", "pMenuItemContent", ""]],
        hostVars: 1,
        hostBindings: function MenuItemContent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("e2e-menu-item-content", true);
          }
        },
        inputs: {
          item: [0, "pMenuItemContent", "item"]
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        attrs: _c0,
        decls: 5,
        vars: 3,
        consts: [["itemContent", ""], [1, "p-menuitem-content", 3, "click"], ["role", "menuitem", "pRipple", "", 1, "p-menuitem-link", 3, "target", "ngClass"], ["role", "menuitem", "pRipple", "", 1, "p-menuitem-link", 3, "routerLink", "queryParams", "routerLinkActivePath", "target", "ngClass", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "p-menuitem-icon", 3, "icon", "fixedWidth"], [1, "p-menuitem-text"], [1, "p-menuitem-text", 3, "innerHTML"], [1, "p-menuitem-badge", 3, "ngClass"]],
        template: function MenuItemContent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵlistener("click", function MenuItemContent_Template_div_click_0_listener($event) {
              return ctx.onItemClick($event, ctx.item);
            });
            i0.ɵɵconditionalCreate(1, MenuItemContent_Conditional_1_Template, 2, 2);
            i0.ɵɵconditionalCreate(2, MenuItemContent_Conditional_2_Template, 1, 4);
            i0.ɵɵtemplate(3, MenuItemContent_ng_template_3_Template, 4, 3, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵattribute("data-pc-section", "content");
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.itemTemplate ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.itemTemplate ? 2 : -1);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgTemplateOutlet, RouterModule, i2.RouterLink, UiIconsModule, i3.UiIconComponent, UiRouterLinkActivePathDirective],
        styles: [_c10],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return MenuItemContent;
})();
export let UiMenuComponent = /*#__PURE__*/(() => {
  class UiMenuComponent extends MenuBase {
    constructor(document2, platformId, el, renderer, cd2, config, overlayService) {
      super(document2, platformId, el, renderer, cd2, config, overlayService);
      this.document2 = document2;
      this.el = el;
      this.renderer = renderer;
      this.config = config;
      this.overlayService = overlayService;
      // for some reason, the DomRect is calculated wrongly when the menu is within toolbar tabMenu. using a custom input to allow specifying a offset to "fix" this.
      this.alignRight = false;
      this.alignRightOffset = 0;
      this.autoFocus = false; // controls focus behavior when used as popup
      this.positionMode = 'aligned';
    }
    /**
     * some logic had to be expanded to provide further functionality:
     * - support displaying as popup at cursor (using .show(...,atCursor=true))
     * - fix dirty DOM in ngOnDestroy - explicitly remove container from DOM to be sure it cannot be rendered during teardown.
     */
    show(event, atCursor = false) {
      this.positionMode = atCursor ? 'cursor' : 'aligned';
      this.cursorPosition = {
        x: event.pageX,
        y: event.pageY
      };
      // giving focus to submenu only if using keyboard.
      // this is because the focused first menuitem style can be quite irritating.
      this.autoFocus = event instanceof KeyboardEvent;
      super.show(event);
    }
    alignOverlay() {
      if (this.positionMode === 'aligned') {
        // default behavior
        if (this.alignRight) absolutePosition__alignRight(this.container, this.target, this.alignRightOffset);else DomHandler.absolutePosition(this.container, this.target);
      } else {
        // behavior borrowed from contextmenu
        this.positionAtCursor();
      }
    }
    appendOverlay() {
      if (this.appendTo === 'body' || this.positionMode === 'cursor') this.renderer.appendChild(this.document2.body, this.container);else if (this.appendTo) DomHandler.appendChild(this.container, this.appendTo);
    }
    restoreOverlayAppend() {
      if (!this.container) return; // cant do anything
      if (this.positionMode === 'cursor' || this.appendTo) {
        this.el.nativeElement.appendChild(this.container);
      }
    }
    // only change in here is conditional focusing
    onOverlayAnimationStart(event) {
      switch (event.toState) {
        case 'visible':
          if (this.popup) {
            this.container = event.element;
            this.moveOnTop();
            this.onShow.emit({});
            this.appendOverlay();
            this.alignOverlay();
            this.bindDocumentClickListener();
            this.bindDocumentResizeListener();
            this.bindScrollListener();
            if (this.autoFocus) {
              DomHandler.focus(this.listViewChild.nativeElement);
              this.changeFocusedOptionIndex(0);
            }
          }
          break;
        case 'void':
          this.onOverlayHide();
          this.onHide.emit({});
          break;
      }
    }
    // borrowed from primeng contextmenu.position
    positionAtCursor() {
      const doc = this.document2;
      let left = this.cursorPosition.x + 1;
      let top = this.cursorPosition.y + 1;
      let width = this.containerViewChild.nativeElement.offsetParent ? this.containerViewChild.nativeElement.offsetWidth : DomHandler.getHiddenElementOuterWidth(this.containerViewChild.nativeElement);
      let height = this.containerViewChild.nativeElement.offsetParent ? this.containerViewChild.nativeElement.offsetHeight : DomHandler.getHiddenElementOuterHeight(this.containerViewChild.nativeElement);
      let viewport = DomHandler.getViewport();
      //flip
      if (left + width - doc.scrollingElement.scrollLeft > viewport.width) {
        left -= width;
      }
      //flip
      if (top + height - doc.scrollingElement.scrollTop > viewport.height) {
        top -= height;
      }
      //fit
      if (left < doc.scrollingElement.scrollLeft) {
        left = doc.scrollingElement.scrollLeft;
      }
      //fit
      if (top < doc.scrollingElement.scrollTop) {
        top = doc.scrollingElement.scrollTop;
      }
      this.containerViewChild.nativeElement.style.left = left + 'px';
      this.containerViewChild.nativeElement.style.top = top + 'px';
    }
    ngOnDestroy() {
      if (this.popup) {
        if (this.container?.parentElement) this.container.parentElement.removeChild(this.container);
      }
      this.container = null;
      super.ngOnDestroy();
    }
    static {
      this.ɵfac = function UiMenuComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiMenuComponent)(i0.ɵɵdirectiveInject(DOCUMENT), i0.ɵɵdirectiveInject(PLATFORM_ID), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i4.PrimeNGConfig), i0.ɵɵdirectiveInject(i4.OverlayService));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiMenuComponent,
        selectors: [["ui-menu"]],
        inputs: {
          alignRight: "alignRight",
          alignRightOffset: "alignRightOffset"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 1,
        consts: [["container", ""], ["list", ""], [3, "ngClass", "class", "ngStyle"], [3, "click", "ngClass", "ngStyle"], [1, "p-menu-start"], ["role", "menu", 1, "p-menu-list", "p-reset", 3, "focus", "blur", "keydown"], [1, "p-menu-end"], [4, "ngTemplateOutlet"], ["role", "separator", 1, "p-menuitem-separator", 3, "ngClass"], ["role", "none", 1, "p-submenu-header", 3, "ngClass"], [3, "innerHTML"], ["role", "none", 1, "p-menuitem", 3, "pMenuItemContent", "itemTemplate", "ngClass", "ngStyle", "class"], ["role", "none", 1, "p-menuitem", 3, "onMenuItemClick", "pMenuItemContent", "itemTemplate", "ngClass", "ngStyle"]],
        template: function UiMenuComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, UiMenuComponent_Conditional_0_Template, 8, 25, "div", 2);
          }
          if (rf & 2) {
            i0.ɵɵconditional(!ctx.popup || ctx.visible ? 0 : -1);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgTemplateOutlet, i1.NgStyle, RouterModule, UiIconsModule, MenuItemContent, SafeHtmlPipe],
        styles: [_c10],
        encapsulation: 2,
        data: {
          animation: [trigger('overlayAnimation', [transition(':enter', [style({
            opacity: 0,
            transform: 'scaleY(0.8)'
          }), animate('{{showTransitionParams}}')]), transition(':leave', [animate('{{hideTransitionParams}}', style({
            opacity: 0
          }))])])]
        },
        changeDetection: 0
      });
    }
  }
  return UiMenuComponent;
})();
export let UiMenuWithMobileTransitionComponent = /*#__PURE__*/(() => {
  class UiMenuWithMobileTransitionComponent {
    constructor(screen, renderer, router, route, cd) {
      this.screen = screen;
      this.renderer = renderer;
      this.router = router;
      this.route = route;
      this.cd = cd;
      this.breakpoint = 959;
      this.activeMenuItemTitle = '';
      this.isMobile$ = screen.windowWidth$.pipe(takeWhileAlive(), map(width => {
        return width <= this.breakpoint;
      }));
      this.router.events.pipe(filter(e => e instanceof NavigationEnd), takeWhileAlive()).subscribe(() => {
        this.updateActiveItems();
      });
    }
    updateActiveItems() {
      const activeItems = RouterLinkHelper.findActiveMenuItems(this.router, this.route, this.model);
      this.activeMenuItemTitle = '';
      if (activeItems.activeItems.length) this.activeMenuItemTitle = activeItems.activeItems[0].label;else if (activeItems.itemsInActivePath.length) this.activeMenuItemTitle = activeItems.itemsInActivePath[0].label;
      this.cd.markForCheck();
    }
    ngAfterViewInit() {
      this.updateActiveItems();
    }
    static {
      this.ɵfac = function UiMenuWithMobileTransitionComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiMenuWithMobileTransitionComponent)(i0.ɵɵdirectiveInject(i5.ScreenService), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i2.Router), i0.ɵɵdirectiveInject(i2.ActivatedRoute), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiMenuWithMobileTransitionComponent,
        selectors: [["ui-menu-with-mobile-transition"]],
        viewQuery: function UiMenuWithMobileTransitionComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c11, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentMenu = _t.first);
          }
        },
        inputs: {
          model: "model",
          breakpoint: "breakpoint"
        },
        decls: 5,
        vars: 7,
        consts: [["contentMenu", ""], [1, "mobile-wrapper", "ui-margin"], ["appendTo", "body", 3, "model", "popup"], [1, "mobile-wrapper", "ui-margin", 3, "click"], ["uiButton", "", "label", "Men\u00FC", "icon", "bars", 1, "ui-button-grey"], [1, "active-menu-item"]],
        template: function UiMenuWithMobileTransitionComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, UiMenuWithMobileTransitionComponent_Conditional_0_Template, 4, 1, "div", 1);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵelement(2, "ui-menu", 2, 0);
            i0.ɵɵpipe(4, "async");
          }
          if (rf & 2) {
            i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 3, ctx.isMobile$) ? 0 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("model", ctx.model)("popup", i0.ɵɵpipeBind1(4, 5, ctx.isMobile$));
          }
        },
        dependencies: [CommonModule, RouterModule, UiIconsModule, UiButtonComponent, UiMenuComponent, i1.AsyncPipe],
        styles: [".mobile-wrapper[_ngcontent-%COMP%]{display:flex;align-items:center;cursor:pointer}.active-menu-item[_ngcontent-%COMP%]{margin:0 0 0 10px;color:inherit}\n\n/*# sourceMappingURL=menu.ts-angular-inline--5.css.map*/"]
      });
    }
  }
  return UiMenuWithMobileTransitionComponent;
})();